import gql from "graphql-tag";
import {PaxNodeComplianceFieldsWithAuthFragment} from "../Queries/Compliance";

export default gql`
mutation SetPaxSelectedISNResult($_id: ID!, $_rev: ID!, $payload: AWSJSON!){
    setIsnSelection(_id: $_id, _rev: $_rev, payload: $payload){
        _id
        _rev
        ...PaxNodeComplianceFieldsWithAuthFragment
    }
}
${PaxNodeComplianceFieldsWithAuthFragment}
`